import { StoreSchema } from '../../../shared/config/storeConfig/StoreSchema'

export const selectIsLoading = (store: StoreSchema) => store.authUser.isLoading